module.exports = {"141032100":"芝河镇","141032101":"桑壁镇","141032203":"坡头乡","141032205":"乾坤湾乡","141032206":"望海寺乡","141032207":"楼山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141032.json
// module id = 461
// module chunks = 0